module.exports = __webpack_public_path__ + "media/components/live/rdc/images/how-it-works-3-dc9677926ea70b2538073d0cf40747bc.png";